import axios from 'axios'
import store from '../store'
import { initRouter as router } from '@/router/index'
import * as auth from '@/utils/auth'
import { message } from 'ant-design-vue'

message.config({
  maxCount: 1,
})

const ajax = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 3000 * 60,
})
ajax.interceptors.request.use((config) => {
  const refresh_token_time = localStorage.getItem('refresh_token_time')
  //如果两小时没有进行操作，则退出登录
  if (Date.now() > +refresh_token_time) {
    message.destroy()
    message.warn('登录过期，请重新登录')
    auth.logout()
    try {
      router.push({ path: '/login', query: { redirect: router.history.current.fullPath } })
    } catch (e) {
      router.push('/login')
    }
  }
  // 如果 token 存在
  const token = store.getters['account/token']()
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token
  }
  return config
})
ajax.interceptors.response.use(
  (res) => {
    return res
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      message.destroy()
      message.warn('登录过期，请重新登录')
      setTimeout(() => {
        auth.logout()
        router.push('/login')
      }, 1000)
    }
    return Promise.reject(error)
  }
)

const InterfaceHttp = (req, config = { message: true }) => {
  return new Promise((resolve, reject) => {
    req
      .then((res) => {
        if (res.data.isSuccess) {
          resolve(res.data)
        } else {
          config.message && message.error(res.data.message)
          reject(res.data)
        }
      })
      .catch((err) => {
        // 网络错误等异常
        reject(err)
        try {
          if (config.message && err.response && err.response.data) {
            message.error(err.response.data.message)
          }
        } catch (e) {
          if (config.message) {
            const errorMsg = (err.data && err.data.message) || err.message || (err.response && err.response.data && err.response.data.message) || '请求失败'
            message.error(errorMsg)
          }
        }
      })
  })
}

function serializeData(data) {
  const arr = []

  const serialize = (obj, pName = '') => {
    for (let key in obj) {
      if (typeof obj[key] === 'undefined') continue
      switch (Object.prototype.toString.call(obj[key])) {
        case '[object Object]':
          serialize(obj[key], key + '.')
          break
        case '[object Array]':
          let array = obj[key]
          for (let i = 0; i < array.length; i++) {
            if (typeof array[i] !== 'undefined') {
              arr.push(`${pName + key}=${array[i]}`)
            }
          }
          break
        default:
          arr.push(`${pName + key}=${obj[key]}`)
      }
    }
  }

  serialize(data)
  return arr.join('&')
}

// 获取菜单列表
export const getUserModule = (params) => {
  return InterfaceHttp(ajax.post('/user/v1/ClientApplicationModule/getUserModule', params))
}

// 获取机构列表
export const getOrgList = (params) => {
  return ajax.get('/user/v1/organization/pagelist', { params })
}

/**权限管理**/
// 系统应用
// 系统应用列表
export const applicationList = (params) => {
  return ajax.get('/user/v1/ClientApplication/getByRoleType', { params })
}
export const applicationPageList = (params) => {
  return ajax.get('/user/v1/ClientApplication/pagelist', { params })
}
// 添加系统应用
export const addApplication = (params) => {
  return ajax.post('/user/v1/ClientApplication/add', params)
}
// 删除系统应用
export const deleteApplication = (params) => {
  return ajax.post('/user/v1/ClientApplication/delete', params)
}
// 修改系统应用
export const editApplication = (params) => {
  return ajax.post('/user/v1/ClientApplication/update', params)
}
// 修改系统应用状态
export const updateStatus = (params) => {
  return ajax.post('/user/v1/ClientApplication/updateStatus', params)
}
// 获取机构名称
export const loadAllByType = (params) => {
  return ajax.get('/user/v1/Organization/OrganizationSelectOptions', { params })
}

// 系统用户
// 系统用户列表
export const adminList = (params) => {
  return ajax.get('/user/v1/Admin/PlatformAdminPageList', { params })
}
// 新增系统用户
export const addAdmin = (params) => {
  return ajax.post('/user/v1/Admin/add', params)
}
// 编辑系统用户
export const editAdmin = (params) => {
  return ajax.post('/user/v1/Admin/update', params)
}
// 修改系统用户状态
export const updateStatusAdmin = (params) => {
  return ajax.post('/user/v1/Admin/updatestate', params)
}
// 修改系统用户密码
export const updatepwd = (params) => {
  return ajax.post('/user/v1/Admin/updatepwd', params)
}
// 删除系统用户
export const deleteAdmin = (params) => {
  return ajax.post('/user/v1/Admin/delete', params)
}

// 角色配置列表
export const userrole = (params) => {
  return ajax.get('/user/v1/AdminAssignRole/AdminRole?' + serializeData(params))
}
// 角色配置提交
export const submituserrole = (params) => {
  return ajax.post('/user/v1/AdminAssignRole/AdminAssignRole', params)
}

// 系统角色

// 系统角色列表
export const roleList = (params) => {
  return ajax.get('/user/v1/role/pagelist', { params })
}
// 添加系统角色
export const addRole = (params) => {
  return ajax.post('/user/v1/role/add', params)
}
// 删除系统角色
export const deleteRole = (params) => {
  return ajax.post('/user/v1/role/delete', params)
}
// 修改系统角色
export const updateRole = (params) => {
  return ajax.post('/user/v1/role/update', params)
}
// 获取权限配置
export const getauthorize = (params) => {
  return InterfaceHttp(ajax.get('/user/v1/RoleAuthority/getauthorize', { params }))
}
// 权限配置
export const editauthorize = (params) => {
  return ajax.post('/user/v1/RoleAuthority/edit', params)
}

// 系统模块
// 查询系统模块树结构
export const treeList = (params) => {
  return ajax.get('/user/v1/ClientApplicationModule/getModulesByApplicationId', { params })
}
// 新增系统模块
export const addModule = (params) => {
  return ajax.post('/user/v1/ClientApplicationModule/add', params)
}
// 修改系统模块
export const updateModule = (params) => {
  return ajax.post('/user/v1/ClientApplicationModule/update', params)
}
// 删除系统模块
export const deleteModule = (params) => {
  return ajax.post('/user/v1/ClientApplicationModule/delete', params)
}
// 新增功能
export const addModuleAuthorize = (params) => {
  return ajax.post('/user/v1/Authorize/add', params)
}
// 修改功能
export const editModuleAuthorize = (params) => {
  return ajax.post('/user/v1/Authorize/update', params)
}
// 删除功能
export const deleteModuleAuthorize = (params) => {
  return ajax.post('/user/v1/Authorize/delete', params)
}
// 修改功能状态
export const updateModuleAuthorize = (params) => {
  return ajax.post('/user/v1/Authorize/update', params)
}
// 功能列表
export const moduleAuthorizeList = (params) => {
  return ajax.get('/user/v1/Authorize/pagelist', { params })
}

// 算分码
// 算分码列表
export const AlgorithmCodePageList = (params) => {
  return ajax.get('/content/v1/AlgorithmCode/pagelist', { params })
}
// 新增算分码
export const addAlgorithmCode = (params) => {
  return ajax.post('/content/v1/AlgorithmCode/add', params)
}
// 修改算分码
export const editAlgorithmCode = (params) => {
  return ajax.post('/content/v1/AlgorithmCode/edit', params)
}
// 删除算分码
export const deleteAlgorithmCode = (params) => {
  return ajax.post('/content/v1/AlgorithmCode/delete', params)
}
// 获取算分码游戏
export const getContentsByCode = (params) => {
  return ajax.get('/content/v1/AlgorithmCode/getContentsByCode', { params })
}
// 获取所有算分码
export const getAllCodes = (params) => {
  return ajax.get('/content/v1/AlgorithmCode/getAllCodes', { params })
}
// 绑定算分码
export const bindCode = (params) => {
  return ajax.post('/content/v1/ContentAlgorithmCodeConfig/bindCode', params)
}
// 添加训练游戏、题目壳（新）
export const AddTrainingGame = (params) => {
  return InterfaceHttp(ajax.post('/content/v1/content/AddTrainingGame', params))
}
// 编辑训练游戏（新）
export const EditTrainingGame = (params) => {
  return InterfaceHttp(ajax.post('/content/v1/content/EditTrainingGame', params))
}
// 获取训练游戏详情（新）
export const GetTrainingContentDetail = (params) => {
  return InterfaceHttp(ajax.get('/content/v1/content/GetTrainingContentDetail', { params }))
}
// 测评游戏
// 测评游戏、训练游戏、视频列表
export const EGamegelist = (params) => {
  return ajax.get('/content/v1/content/getpagelist', { params })
}
// 游戏列表
export const contentlist = (params) => InterfaceHttp(ajax.get('/content/v1/content/getGamePageList?' + serializeData(params)))
// 转商用、转科研
export const UpdataClassifyTag = (params) => {
  return ajax.post('/content/v1/content/UpdataClassifyTag', params)
}
// 测评游戏统计
export const GetContentStatistics = (params) => {
  return ajax.get('/data/v1/ContentStatistics/GetContentStatistics', { params })
}
// 测评游戏统计详情
export const GetContentStatisticsByAge = (params) => {
  return ajax.get('/data/v1/ContentStatistics/GetContentStatisticsByAge', { params })
}
// 训练游戏统计
export const GetTrainContentStatistics = (params) => {
  return ajax.get('/data/v1/ContentStatistics/GetTrainContentStatistics', { params })
}
// 训练游戏统计详情
export const GetTrainContentStatisticsByAge = (params) => {
  return ajax.get('/data/v1/ContentStatistics/GetTrainContentStatisticsByAge', { params })
}

// 右边抽屉表格
export const getAbilityWithAlgorithmCode = (params) => {
  return ajax.get('/content/v1/content/getAbilityWithAlgorithmCode', { params })
}
// 测评游戏版本
export const EGamegeVersion = (params) => {
  return ajax.get('/content/v1/content/getVersionList', { params })
}
// 添加测评游戏
export const addEGamege = (params) => {
  return ajax.post('/content/v1/content/addContent', params)
}
// 删除测评游戏
export const deleteEGamege = (params) => {
  return ajax.post('/content/v1/content/deleteContent', params)
}
// 修改测评游戏
export const updataEGamege = (params) => {
  return ajax.post('/content/v1/content/updataContent', params)
}
// 修改游戏状态
export const updatestatus = (params) => {
  return ajax.post('/content/v1/content/updatestatus', params)
}
// 根据ID获取基本信息
export const getDetailByid = (params) => {
  return ajax.get('/content/v1/content/detail', { params })
}
// 根据ID获取视频基本信息
export const getVideoDetail = (params) => {
  return ajax.get('/content/v1/content/videoDetail', { params })
}
// 获取能力下拉
export const abilitySelect = (params) => {
  return ajax.get('/content/v1/ability/loadall', { params })
}
// 根据内容id获取能力列表
export const getAbilityListByContentId = (params) => {
  return ajax.get('/content/v1/content/getAbilityListByContentId', { params })
}
// 获取具体内容版本下的能力算分码绑定关系
export const getAbilityListByVersionId = (params) => {
  return ajax.get('/content/v1/content/getAbilityListByVersionId', { params })
}
// 添加测评游戏能力
export const addAbility = (params) => {
  return ajax.post('/content/v1/content/addAbility', params)
}
// 编辑测评游戏能力
export const updataAbility = (params) => {
  return ajax.post('/content/v1/content/updataAbility', params)
}
// 删除测评游戏能力
export const deleteAbility = (params) => {
  return ajax.post('/content/v1/content/deleteAbility', params)
}
// 添加测评游戏、题目壳版本
export const addContentVersion = (params) => {
  return ajax.post('/content/v1/content/addContentVersion', params)
}
// 编辑测评游戏版本
export const updataContentVersion = (params) => {
  return ajax.post('/content/v1/content/updataContentVersion', params)
}
// 删除测评游戏版本
export const deleteContentVersion = (params) => {
  return ajax.post('/content/v1/content/deleteContentVersion', params)
}
// 更新游戏版本状态
export const updateVersionStatus = (params) => {
  return InterfaceHttp(ajax.post('/content/v1/content/updateVersionStatus', params))
}
export const copyQuestionGroup = (params) => ajax.post('/content/v1/QuestionGroup/CopyQuestionGroup', params)
export const getquestiongroupbyid = (params) => {
  return ajax.post('/content/v1/game/getquestiongroupbyid', params)
}
// 题目壳模板下拉框
export const questiongrouptemplate = (params) => {
  return ajax.get('/content/v1/questiongrouptemplate/loadall', { params })
}
// 视频能力类型
export const loadallsel = (params) => {
  return ajax.get('/content/v1/Ability/loadallsel', { params })
}
// 添加视频
export const addContentVideo = (params) => {
  return ajax.post('/content/v1/content/addContentVideo', params)
}
// 编辑视频
export const updataContentVideo = (params) => {
  return ajax.post('/content/v1/content/updataContentVideo', params)
}

// 关联视频
export const RelevanceVideo = (params) => {
  return ajax.post('/content/v1/Content/RelevanceVideo', params)
}
// 获取视频关联信息
export const GetContentRelevanceByContentId = (params) => {
  return ajax.get('/content/v1/Content/GetContentRelevanceByContentId', { params })
}

// 学业学习力权重列表
export const learnList = (params) => {
  return ajax.get('/content/v1/learningabilityweightconfig/indexpagelist', { params })
}
//学业学习力权重查看列表
export const learnDetailList = (params) => {
  return ajax.get('/content/v1/learningabilityweightconfig/pagelist', { params })
}
//学业学习力权重导入
export const learnUpload = (params) => {
  return ajax.post('/content/v1/learningabilityweightconfig/upload', params)
}
//学业学习力权重删除
export const learnDelete = (params) => {
  return ajax.post('/content/v1/learningabilityweightconfig/delete', params)
}

//学科及满分列表
export const subjectList = (params) => {
  return ajax.get('/content/v1/subjectscoreconfig/indexpagelist', { params })
}
//学科及满分列表
export const subjectDetailList = (params) => {
  return ajax.get('/content/v1/subjectscoreconfig/pagelist', { params })
}
//学科及满分导入
export const subjectUpload = (params) => {
  return ajax.post('/content/v1/subjectscoreconfig/upload', params)
}
//学科及满分删除
export const subjectDelete = (params) => {
  return ajax.post('/content/v1/subjectscoreconfig/delete', params)
}

// 总分学科构成表列表
export const totalScoreList = (params) => {
  return ajax.get('/content/v1/TotalScoreModel/indexpagelist', { params })
}
// 总分学科构成表列表
export const totalScoreDetailList = (params) => {
  return ajax.get('/content/v1/TotalScoreModel/pagelist', { params })
}
// 总分学科构成表导入
export const totalScoreUpload = (params) => {
  return ajax.post('/content/v1/TotalScoreModel/upload', params)
}
// 总分学科构成表删除
export const totalScoreDelete = (params) => {
  return ajax.post('/content/v1/TotalScoreModel/delete', params)
}

// 学业潜能列表
export const potentialList = (params) => {
  return ajax.get('/content/v1/potentialweightconfig/indexpagelist', { params })
}
// 学业潜能列表
export const potentialDetailList = (params) => {
  return ajax.get('/content/v1/potentialweightconfig/pagelist', { params })
}
// 学业潜能导入
export const potentialUpload = (params) => {
  return ajax.post('/content/v1/potentialweightconfig/upload', params)
}
// 学业潜能删除
export const potentialDelete = (params) => {
  return ajax.post('/content/v1/potentialweightconfig/delete', params)
}

// 题目壳模板列表
export const templateList = (params) => {
  return ajax.get('/content/v1/questiongrouptemplate/pagelist', { params })
}
// 题目壳模板修改状态
export const templateUpdatestatus = (params) => {
  return ajax.post('/content/v1/questiongrouptemplate/updatestatus', params)
}
// 题目壳模板校验能否修改状态
export const checkstatus = (params) => {
  return ajax.post('/content/v1/questiongrouptemplate/checkstatus', params)
}
// 题目壳模板添加
export const addTemplateUpdate = (params) => {
  return ajax.post('/content/v1/questiongrouptemplate/add', params)
}
// 题目壳模板修改
export const updateTemplateUpdate = (params) => {
  return ajax.post('/content/v1/questiongrouptemplate/update', params)
}
// 题目壳模板删除
export const deleteTemplate = (params) => {
  return ajax.post('/content/v1/questiongrouptemplate/delete', params)
}
// 能力维度列表
export const abilityList = (params) => {
  return ajax.get('/content/v1/ability/loadall', { params })
}
// 能力维度状态切换
export const abilityUpdatestatus = (params) => {
  return ajax.post('/content/v1/ability/updatestatus', params)
}
// 添加能力维度
export const abilityAdd = (params) => {
  return ajax.post('/content/v1/ability/add', params)
}
// 编辑能力维度
export const abilityEdit = (params) => {
  return ajax.post('/content/v1/ability/update', params)
}
// 删除能力维度
export const abilityDelete = (params) => {
  return InterfaceHttp(ajax.post('/content/v1/ability/delete', params))
}
// 新增题目
export const questionsAdd = (params) => {
  return InterfaceHttp(ajax.post('/content/v1/questions/add', params))
}
// 修改题目
export const questionsUpdate = (params) => {
  return InterfaceHttp(ajax.post('/content/v1/questions/update', params))
}
// 题目详情
export const questionsDetail = (params) => {
  return InterfaceHttp(ajax.get('/content/v1/Questions/detail', { params }))
}
// 题目管理列表
export const questionsList = (params) => {
  return ajax.get('/content/v1/questions/pagelist', { params })
}
// 题目管理删除
export const questionsDelete = (params) => {
  return InterfaceHttp(ajax.post('/content/v1/Questions/delete', params))
}

// 题目管理列表状态修改
export const questionsUpdatestatus = (params) => {
  return ajax.post('/content/v1/questions/updatestatus', params)
}
// 批量导入题目
export const questionsImport = (params) => {
  return InterfaceHttp(ajax.post('/content/v1/questions/upload?filePath=content/question/import', params))
}

// 课程管理能力标签下拉
export const courseAbilitySelect = (params) => {
  return ajax.get('/content/v1/ability/loadallsel', { params })
}
// 课时管理列表修改name
export const updateCourseChildName = (params) => {
  return ajax.patch('/courseResource/v1/course-sessions/name', params)
}

// 课时清空快照
export const UpdateCourseChildSnapshot = (params) => {
  return ajax.post('/coursecenter/v1/UserChildCourse/UpdateCourseChildSnapshot', params)
}
// 机构清空快照
export const UpdatrCourseChildContents = (params) => {
  return ajax.post('/coursecenter/v1/UserChildCourseContentSnapshot/UpdateCourseChildContents', params)
}

// 推荐内容配置列表
export const updateDisplayOrder = (params) => {
  return ajax.post('/content/v1/ChildCourseItemConfig/updateDisplayOrder', params)
}
// 推荐内容配置列表添加 获取黑名单列表
export const getContentlist = (params) => {
  return ajax.get('/content/v1/Content/getContentlist?' + serializeData(params))
}
// 推荐内容配置列表添加
export const itemConfigListAdd = (params) => {
  return ajax.post('/content/v1/ChildCourseItemConfig/addconfig', params)
}
// 推荐内容配置列表指导视频开关
export const UpdateItemConfigLinkVedioStatus = (params) => {
  return ajax.post('/content/v1/ChildCourseItemConfig/UpdateLinkVedioStatus', params)
}
// 推荐内容配置列表编辑
export const itemConfigListUpdate = (params) => {
  return ajax.post('/content/v1/ChildCourseItemConfig/updateconfig', params)
}
// 推荐内容配置列表添加
export const itemConfigListDelete = (params) => {
  return ajax.post('/content/v1/ChildCourseItemConfig/deleteconfig', params)
}
// 推荐内容配置列表添加 获取一级能力
export const GetBasicAbilities = (params) => {
  return ajax.get('/content/v1/ability/loadall', { params })
}

// 获取内容列表
export const contentPagelist = (params) => {
  return ajax.get('/content/v1/content/pagelist', { params })
}

// 添加报告获取报告能力
export const reportAbilityList = (params) => {
  return ajax.get('/content/v1/ability/loadallsel', { params })
}

// 获取GetByAbilityEvaluationSysId
export const getmatchinfo = (params) => {
  return ajax.get('/content/v1/traingame/getmatchinfo', { params })
}
export const saveMatchSetting = (params) => {
  return ajax.post('/content/v1/TrainGameLevelMatchSetting/edit', params)
}
export const getMatchSetting = (params) => {
  return ajax.get('/content/v1/TrainGameLevelMatchSetting/get', { params })
}
// 根据GetByAbilityEvaluationSysId获取列表
export const matchList = (params) => {
  return ajax.get('/content/v1/AbilityLevelConfig/GetByAbilityEvaluationSysId', { params })
}
// 获取关卡下拉
export const levelSelect = (params) => {
  return ajax.post('/content/v1/traingamecheckpointconfig/loadallbytaingameid', params)
}
// 关联游戏列表
export const matchGameList = (params) => {
  return ajax.get('/content/v1/traingame/getevaluationgamespagelist', { params })
}

// 切换能力体系
export const updategameconfig = (params) => {
  return ajax.post('/content/v1/traingame/updategameconfig', params)
}

// 清空设置
export const clearSet = (params) => {
  return ajax.post('/content/v1/traingame/ClearSet', params)
}
// 游戏匹配提交
export const LevelSignSet = (params) => {
  return ajax.post('/content/v1/traingame/LevelSignSet', params)
}
// 开启、关闭年龄匹配
export const agematch = (params) => {
  return ajax.post('/content/v1/traingame/agematch', params)
}
// 年龄匹配列表
export const getagematchlist = (params) => {
  return ajax.get('/content/v1/traingame/getagematchlist', { params })
}

// 删除年龄匹配
export const delagematch = (params) => {
  return ajax.post('/content/v1/traingame/delagematch', params)
}

// 关卡配置项列表
export const levelPagelist = (params) => {
  return ajax.get('/content/v1/traingamecheckpointheader/getlist', { params })
}
// 添加配置项
export const addLevelSet = (params) => {
  return ajax.post('/content/v1/traingamecheckpointheader/add', params)
}
// 删除配置项
export const deleteLevelSet = (params) => {
  return ajax.post('/content/v1/traingamecheckpointheader/delete', params)
}
// 关卡数据列表
export const levelDataList = (params) => {
  return ajax.get('/content/v1/traingamecheckpointconfig/list', { params })
}
// 清除训练游戏关卡缓存
export const clearGameCache = (params) => {
  return ajax.post('/content/v1/TrainGameCheckpointConfig/RemoveCheckPointCache', params)
}
// 添加关卡数据
export const addlevelData = (params) => {
  return ajax.post('/content/v1/traingamecheckpointconfig/add', params)
}
// 删除关卡数据
export const deletelevelData = (params) => {
  return ajax.post('/content/v1/traingamecheckpointconfig/delete', params)
}
// 导入关卡数据
export const inportlevelData = (params) => {
  return InterfaceHttp(ajax.post('/content/v1/traingamelevelmanage/importconfigdata?filePath=content/traingame/checkpoint', params))
}
// 题目壳管理列表
export const questiongrouppagelist = (params) => {
  return ajax.get('/content/v1/content/questiongrouppagelist', { params })
}
// 题目壳管理=>题目设置(跳转设置)
export const getquestionbyidlist = (params) => {
  return ajax.get('/content/v1/questiongroup/getquestionbyidlist', { params })
}
// 题目壳管理=>题目设置=>排序
export const updateorder = (params) => {
  return ajax.post('/content/v1/questiongroup/updateorder', params)
}
// 题目壳管理=>题目设置=>自动排序
export const automaticsorting = (params) => {
  return ajax.post('/content/v1/questiongroup/automaticsorting', params)
}
// 题目壳管理=>题目设置=>删除相关题目
export const deletequertionconfig = (params) => {
  return ajax.post('/content/v1/questiongroup/deletequertionconfig', params)
}
// 题目壳管理=>跳转 获取题目选项列表
export const getquestionitemsbyid = (params) => {
  return ajax.get('/content/v1/questiongroup/getquestionitemsbyid', { params })
}
// 题目壳管理=>跳转 保存跳转设置
export const editskip = (params) => {
  return ajax.post('/content/v1/questiongroup/editskip', params)
}
// 题目壳管理=>跳转 删除跳转设置
export const deleteskip = (params) => {
  return ajax.post('/content/v1/questiongroup/deleteskip', params)
}
// 题目壳管理=>题目配置  批量导入题目
export const addquestionconfig = (params) => {
  return ajax.post('/content/v1/questiongroup/addquestionconfig', params)
}
// 题目壳管理=>题目详情
export const questionDetail = (params) => {
  return ajax.get('/content/v1/questions/detail', { params })
}

// 课时配置（修改训练内容执行次数）
export const UpdateTrainingContentTimes = (params) => {
  return ajax.post('/content/v1/ChildCourseItemConfig/UpdateTrainingContentTimes', params)
}

// 校验课时编辑能否切换状态
export const courseChildCheckStatus = (params) => {
  return ajax.post('/coursecenter/v1/UserChildCourse/IsChildCourseUsing', params)
}
// 校验内容编辑能否切换状态
export const contentCheckStatus = (params) => {
  return ajax.post('/content/v1/content/Checkstatus', params)
}

// 内容中心产品服务
// 列表
export const productServiceList = (params) => {
  return ajax.get('/content/v1/ProductService/pagelist', { params })
}
// 新增
export const productServiceAdd = (params) => {
  return ajax.post('/content/v1/ProductService/add', params)
}
// 详情
export const productServiceDetail = (params) => {
  return ajax.get('/content/v1/ProductService/detail', { params })
}
// 编辑
export const productServiceEdit = (params) => {
  return ajax.post('/content/v1/ProductService/edit', params)
}
// 删除
export const productServiceDelete = (params) => {
  return ajax.post('/content/v1/ProductService/delete', params)
}
// 修改状态
export const productServiceStatue = (params) => {
  return ajax.post('/content/v1/ProductService/updataStatue', params)
}

// 算法配置
export const algorithm = {
  pagelist: (params) => InterfaceHttp(ajax.get('/content/v1/AIContentAlgorithmCoefficient/pagelist?' + serializeData(params))),

  edit: (params) => InterfaceHttp(ajax.post('/content/v1/AIContentAlgorithmCoefficient/edit', params)),

  delete: (params) => InterfaceHttp(ajax.post('/content/v1/AIContentAlgorithmCoefficient/delete', params)),

  detail: (params) => InterfaceHttp(ajax.get('/content/v1/AIContentAlgorithmCoefficient/detail?' + serializeData(params))),
}

/**2021-11-19 修改快照相关**/
// 获取课程需要重新算分的内容列表
export const GetCourseEvaluationContents = (params) => {
  return ajax.get('/2b/coursecenter/v1/UserChildCourseContentSnapshot/GetCourseEvaluationContents', { params })
}
// 添加、重置内容
export const ChildCourseContentSnapshotReset = (params) => {
  return InterfaceHttp(ajax.post('/coursecenter/v1/UserChildCourseContentSnapshot/ChildCourseContentSnapshotReset', params))
}
// 内容列表重新算分
export const UpdateCourseContentScore = (params) => {
  return InterfaceHttp(ajax.post('/coursecenter/v1/ContentScore/UpdateCourseContentScore', params))
}

// 修改系统模块状态
export const systemModuleStatus = (params) => ajax.post('/user/v1/ClientApplicationModule/updatestatus', params)

/**个人中心**/
// 获取信息
export const getAdminInfo = (params) => ajax.get('/user/v1/Admin/AdminInfo', { params })
// 修改基本信息
export const updateInfo = (params) => ajax.post('/user/v1/Admin/updateInfo', params)
// 绑定账号
export const updateAccount = (params) => ajax.post('/user/v1/Admin/updateAccount', params)
// 修改密码获取验证码
export const getCode = (params) => ajax.post('/user/v1/sysuser/getcodebyphone', params)
// 修改手机号获取验证码
export const getPhoneCode = (params) => ajax.post('/user/v1/sysuser/getcodeforupdatephone', params)
// 修改密码
export const updatePass = (params) => ajax.post('/user/v1/Admin/updatepwd', params)

export const changeStatusNew = (params) => ajax.post('/user/v1/admin/updateOrganizationAdminStatus', params)
// 修改手机号
export const updateMobile = (params) => ajax.post('/user/v1/Admin/updateMobile', params)

/* 常模相关 */
export const NormSet = {
  //获取常模对比表数据
  GetNormalContrastData: (params) => {
    return InterfaceHttp(ajax.get('/data/v1/ContentAbilityScore/GetNormalContrastData?' + serializeData(params)))
  },
  GetApproximateScores: (params) => {
    return InterfaceHttp(ajax.get('/data/v1/ContentAbilityScore/GetApproximateScores?' + serializeData(params)))
  },
  // 获取列表
  getList: (params) => {
    return InterfaceHttp(ajax.get('/content/v1/Norm/pagelist?' + serializeData(params)))
  },
  // 获取详情
  getDetail: (params) => {
    return InterfaceHttp(ajax.get('/content/v1/Norm/detail', { params }))
  },
  // 获取游戏名称和版本
  GetGameVersionNorm: (params) => {
    return InterfaceHttp(ajax.get('/content/v1/Norm/GetGameVersionNorm', { params }))
  },
  // 添加/编辑
  NormEdit: (params) => {
    return InterfaceHttp(ajax.post('/content/v1/Norm/edit', params))
  },
  // 提交审核
  NormAudit: (params) => {
    return InterfaceHttp(ajax.post('/content/v1/Norm/Audit', params))
  },
  // 拒绝
  NormReject: (params) => {
    return InterfaceHttp(ajax.post('/content/v1/Norm/Reject', params))
  },
  // 删除
  NormDelete: (params) => {
    return InterfaceHttp(ajax.post('/content/v1/Norm/Delete', params))
  },
  // 常模导入
  NormUpload: (params) => {
    return InterfaceHttp(ajax.post('/content/v1/Norm/upload', params))
  },
  // 切换状态
  NormIsEnabled: (params) => {
    return InterfaceHttp(ajax.post('/content/v1/Norm/IsEnabled', params))
  },

  // 获取上一版本
  GetLastVersionNorm: (params) => {
    return InterfaceHttp(ajax.get('/content/v1/Norm/GetLastVersionNorm', { params }))
  },

  // 获取上一版本
  UpdateNormRemark: (params) => {
    return InterfaceHttp(ajax.post('/content/v1/Norm/UpdateNormRemark', params))
  },
  // 常模历史记录
  getNormVersionList: (params) => InterfaceHttp(ajax.get('/content/v1/Norm/getNormVersionList', { params })),
}

/* 项目实施 -- 机构管理 */
export const Mechanism = {
  //修改用户信息
  updateInfo: (params) => ajax.post('/user/v1/Admin/Update', params),
  // 删除
  DeleteOrganizationAdmin: (params) => ajax.post('/user/v1/Admin/DeleteOrganizationAdmin', params),
  VerifyOrganizationAdmin: (params) => ajax.get('/user/v1/Admin/VerifyOrganizationAdmin', { params }),
  // 智慧云开关
  updateCloudStatus: (params) => ajax.post('/user/v1/Organization/UpdateCloudStatus', params),
  updateCloudStatusMpWx: (params) => ajax.post('/user/v1/Organization/UpdateMiniProgramStatus', params),
  // /content/v1/questions/upload
  AddOrganizationSuperAdmin: (params) => ajax.post('/user/v1/Admin/EditOrganizationSuperAdmin', params),
  // 新增机构-保存
  EditOrganizationModule: (params) => ajax.post('/user/v1/Organization/EditOrganizationModule', params),
  // 模块树
  GetOrganizationModule: (params) => ajax.get('/user/v1/Organization/GetOrganizationModule', { params }),
  // 获取超级管理员
  GetSuperAdmin: (params) => ajax.get('/user/v1/Admin/GetSuperAdmin', { params }),

  //机构表格数据
  mechanismPageList: (params) => {
    return InterfaceHttp(ajax.get('/user/v1/organization/GetPageListWithoutOperateAuth?' + serializeData(params)))
  },
  //删除机构
  deleteOrg: (params) => {
    return InterfaceHttp(ajax.post('/user/v1/organization/delete', params))
  },
  //机构启用禁用
  mechanismTableStatus: (params) => {
    return InterfaceHttp(ajax.post('/user/v1/organization/updatestatus', params))
  },
  //机构地址
  address: (params) => {
    return InterfaceHttp(ajax.get('/base/v1/region/loadchilds', { params }))
  },
  //机构负责人下拉
  GetOrganizationAdmin: (params) => {
    return InterfaceHttp(ajax.get('/user/v1/Organization/GetOrganizationAdmin', { params }))
  },
  //机构角色下拉
  GetRoleOptions: (params) => {
    return InterfaceHttp(ajax.get('/user/v1/Role/GetRoleOptions', { params }))
  },
  //添加机构树结构数据
  treeData: (params) => {
    return InterfaceHttp(ajax.get('/user/v1/organization/loadallsel', { params }))
  },
  // 获取上级机构
  getSuperiorOrg: (params) => {
    return InterfaceHttp(ajax.get('/user/v1/organization/OrganizationSelectOptions?' + serializeData(params)))
  },
  getSuperiorTree: (params) => {
    return InterfaceHttp(ajax.get('/user/v1/Organization/OrganizationTreeOptions?' + serializeData(params)))
  },
  //新增机构
  mechanismOrganizationAdd: (params) => {
    return InterfaceHttp(ajax.post('/user/v1/organization/add', params))
  },
  mechanismOrganizationUpdate: (params) => {
    return InterfaceHttp(ajax.post('/user/v1/organization/update', params))
  },
  // 合并机构
  mergeOrganization: (params) => {
    return InterfaceHttp(ajax.post('/user/v1/Organization/MergeOrganization', params))
  },

  // 数据权限列表数据
  getDataAuthorityList: (params) => {
    return InterfaceHttp(ajax.get('/user/v1/DataAuthority/getauthorize', { params }))
  },
  // 编辑数据权限
  editDataAuthority: (params) => {
    return InterfaceHttp(ajax.post('/user/v1/RoleAuthority/edit', params))
  },
  updateOrganizationSettings: (params) => {
    return InterfaceHttp(ajax.post('/user/v1/Organization/UpdateOrganizationSettings', params))
  },
}

/* 项目实施 -- 用户管理 */
export const UserManage = {
  //根据id获取机构信息
  getOrganizationInfo: (params) => {
    return InterfaceHttp(ajax.get('/user/v1/Organization/detail', { params }))
  },

  // 获取年级班级列表
  getGradeClassList: (params) => InterfaceHttp(ajax.get('/user/v1/OrganizationStructure/AuthorizeGradeClassList', { params })),
  // 新增或编辑年级班级列表
  editGradeClass: (params) => InterfaceHttp(ajax.post('/user/v1/OrganizationStructure/EditOrganizationStructure', params)),
  // 删除年级班级列表
  deleteGradeClass: (params) => InterfaceHttp(ajax.post('/user/v1/OrganizationStructure/delete', params)),
  // 年级是否毕业
  updateGraduateStatus: (params) => InterfaceHttp(ajax.post('/user/v1/OrganizationStructure/UpdateGraduateStatus', params)),

  // 教师分页列表
  newTeacherList: (params) => {
    return InterfaceHttp(ajax.get('/user/v1/admin/OrganizationAdminPagelist', { params }))
  },

  //学生启用禁用
  studentState: (params) => {
    return InterfaceHttp(ajax.post('/user/v1/OrganizationUser/updatestatus', params))
  },
  //新增学生
  addStudent: (params) => {
    return InterfaceHttp(ajax.post('/user/v1/OrganizationUser/add', params))
  },
  //编辑学生
  updateStudent: (params) => {
    return InterfaceHttp(ajax.post('/user/v1/OrganizationUser/update', params))
  },
  //合并学生列表
  MergeOrganizationUserPageList: (params) => InterfaceHttp(ajax.get('/user/v1/OrganizationUser/MergeOrganizationUserPageList?' + serializeData(params))),
  //合并学生
  MergeOrganizationUser(params) {
    return InterfaceHttp(ajax.post('/user/v1/OrganizationUser/MergeOrganizationUser', params))
  },
  //批量删除学生
  deleteStudentsAll: (params) => InterfaceHttp(ajax.post('/user/v1/OrganizationUser/removeList', params)),

  //获取学生详情
  getStudentDetails(params) {
    return InterfaceHttp(ajax.get('/user/v1/OrganizationUser/detail', { params }))
  },

  //获取学生课程
  getStudentCourse(params) {
    return InterfaceHttp(ajax.get('/2b/coursecenter/v1/UserCourse/GetOrganizationUserCoursePageList', { params }))
  },
  //获取学生课程课时
  getStudentClassHour(params) {
    return InterfaceHttp(ajax.get('/2b/coursecenter/v1/UserChildCourse/getUserCourseChildProgress', { params }))
  },

  //获取开通课程列表
  getCourseConfigList: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/CustmoerCourse/PageList', { params })),

  //开通课程
  openCourse: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/OpenCourse/OrganizationUserOpeningCourse', params)),

  //是否生成课程码
  hasCourseCode: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/UserCourse/hascode', { params })),

  //获取课程码
  // getCourseCodeList: params => InterfaceHttp(ajax.get('/content/v1/projectcoursechilduser/GetCourseCodePageList', {params})),
  getCourseCodeList: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/UserCourse/GetCourseCodePageList', { params })),
}

/* 项目实施 -- 课程中心 */
export const Course = {
  checkCourseResource: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/ProjectCourseResource/checkCourseResource', params)),

  getProjectCourseList: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/ProjectCourseResource/getCourseList?' + serializeData(params))),

  courseCheckDeleted: (params) => InterfaceHttp(ajax.post('/coursecenter/v1/UserCourse/CheckDeleted', params)),
  // 获取能力权重的能力
  GetBasicAbilities: (params) => InterfaceHttp(ajax.get('/base/v1/DictionaryParameter/GetBasicAbilities', { params })),

  //获取课程列表
  getCourseList: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/CustmoerCourse/PageList?' + serializeData(params))),
  // 合并课程获取学生列表
  CheckMergeCustomerCourse: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/userCourse/CheckMergeCustomerCourse', params)),
  // 合并课程
  MergeCustomerCourse: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/userCourse/MergeCustomerCourse', params)),

  //删除课程
  courseDelete: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/projectcourseconfig/delete', params)),
  //启用禁用课程
  courseUpdate: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/projectcourseconfig/updateisenable', params)),

  // 新课程详情列表
  newcourseDetailsList: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/CustomerChildCourse/pagelist', { params })),
  //重新算分列表
  GetConfigsByProjectCourseConfigId: (params) => InterfaceHttp(ajax.get('/data/v1/CustomerChildCourseAbilityConfig/GetConfigsByProjectCourseConfigId', { params })),
  //课程详情列表-课时结算
  courseHourSettlement: (params) => InterfaceHttp(ajax.post('/coursecenter/v1/CustomerChildCourse/Settlement', params)), //11.10修改
  //课程详情列表-课时快照列表
  snapshotPagelist: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/UserChildCourseContentSnapshot/ChildCourseContentSnapshotPageList', { params })),
  // 替换内容已选中数据id
  getCourseChildSnapshotContentIds: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/UserChildCourseContentSnapshot/getCourseChildSnapshotContentIds', { params })),
  //课程详情列表-重置快照-替换内容
  replaceChangecontent: (params) => InterfaceHttp(ajax.post('/content/v1/projectcoursechilduser/changecontent', params)),
  // 重新生成个人课时报告 获取课时内容
  GetProjectCoursechildDetail: (params) => InterfaceHttp(ajax.get('/data/v1/CustomerChildCourseAbilityConfig/GetConfigsByProjectCourseChildId', { params })),
  //用户课时列表
  getUserCourseChildProgress: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/UserChildCourse/getUserCourseChildProgressByAuthorize', { params })),
  //用户课时 - 结算
  getUserCourseChildSettlement: (params) => InterfaceHttp(ajax.post('/coursecenter/v1/UserChildCourse/ChildCourseUserSettlement', params)),

  //用户课程列表
  getUserCourseProgress: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/UserCourse/getUserCourseProgress', { params })),
  //用户课程 - 结算
  getUserCourseSettlement: (params) => InterfaceHttp(ajax.post('/coursecenter/v1/UserCourse/CourseUserSettlement', params)),
  //用户课程 - 更新课程
  UpdateUserChildCourseConfig: (params) => InterfaceHttp(ajax.post('/coursecenter/v1/UserCourse/UpdateUserChildCourseConfig', params)),

  //开课设置
  addCourseCourseResourceSetting: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/ProjectCourseConfig/GetChildCourseDeblockRules', { params })),
  //仅配置课程确认
  addCourseConfigCourse: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/ProjectCourseConfig/ConfigCourse', params)),
  // 根据机构id查询机构下的年级和班级
  getGradeDataList: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/Authorize/GradeClassTree', { params })),
  // 根据机构和班级id获取学生
  getAddCourseStudentList: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/UserCourse/ProjectCourseUserInfoPageList', { params })),
  // 添加课程
  setOpeningCoursesAsync: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/OpenCourse/OpeningCoursesAsync', params)),

  //课程资源
  //课程资源列表记录
  getUsageRecord: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/ProjectCourseResource/getUsageRecord', { params })),
  addCourseResourceDetailList: (params) => InterfaceHttp(ajax.get('/content/v1/ProjectCourseResource/detail', { params })),

  // 添加编辑训练测评资源
  addCourseResource: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/ProjectCourseResource/edit', params)),
  // 添加课程第三步 根据id获取课程信息
  getmodel: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/ProjectCourseConfig/getmodel', { params })),

  //课时资源-查看内容-视频预览
  GetPlayAuth: (params) => InterfaceHttp(ajax.get('/content/v1/Content/GetPlayAuth?' + serializeData(params))),

  // 区域项目-设置
  SubordinateCustomerCoursePageList: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/CustmoerCourse/SubordinateCustomerCoursePageList', { params })),
  // 区域项目 重算分数弹窗
  GetSuperiorCustomerCourseEvaluationContents: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/UserChildCourseContentSnapshot/GetSuperiorCustomerCourseEvaluationContents', { params })),
  // 区域项目 重算分数
  UpdateCourseContentScore: (params) => InterfaceHttp(ajax.post('/coursecenter/v1/ContentScore/UpdateSuperiorCustomerCourseContentScore', params)),
}

/* 报告中心 -- 团体报告 */
export const GroupReport = {
  //获取团体报告列表
  getGroupReportList: (params) => InterfaceHttp(ajax.get('/data/v1/groupreport/pagelist', { params })),
  //团体报告列表新增
  groupReportAdd: (params) => InterfaceHttp(ajax.post('/data/v1/groupreport/add', params)),
  //团体报告列表修改
  groupReportEdit: (params) => InterfaceHttp(ajax.post('/data/v1/groupreport/edit', params)),
  //团体报告列表删除
  groupReportDelete: (params) => InterfaceHttp(ajax.post('/data/v1/groupreport/delete', params)),
  // 团体报告列表删除后修改课程状态
  updateCourseStatus: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/projectCourseConfig/UpdateStatus', params)),

  //添加报告-获取课时列表
  getCourseChildList: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/ProjectCourseChild/pagelist', { params })),
  //添加报告-获取团体报告配置课程信息
  getGroupReportCourseInfo: (params) => InterfaceHttp(ajax.get('/data/v1/GroupReportCourse/GetGroupReportCourseInfo', { params })),
  //添加报告-配置学生页面展示
  getGroupReportCourseSettings: (params) => InterfaceHttp(ajax.post('/data/v1/GroupReportCourse/GetGroupReportCourseSettings', params)),
  //添加报告-删除课程
  deleteCourseChild: (params) => InterfaceHttp(ajax.post('/data/v1/GroupReportCourse/delete', params)),
  //编辑添加测评轮次
  editSample: (params) => InterfaceHttp(ajax.post('/data/v1/GroupReportSample/edit', params)),
  //人员配置保存
  updateParticipantConfig: (params) => InterfaceHttp(ajax.post('/data/v1/GroupReportCourse/UpdatParticipantConfig', params)),
  //修改学生样本取样方法
  updateStudentSampleTakingMethod: (params) => InterfaceHttp(ajax.post('/data/v1/GroupReport/UpdateStudentSampleTakingMethod', params)),

  // 第三步 团体报告 获取能力配置 机构列表
  GetGroupReportProjectCoursechildDetail: (params) => InterfaceHttp(ajax.get('/data/v1/GroupReportCourse/GetGroupReportProjectCoursechildDetail', { params })),
  // 第三步 团体报告 能力配置
  UpdatContentAbilityConfigs: (params) => InterfaceHttp(ajax.post('/data/v1/GroupReportCourse/UpdatContentAbilityConfigs', params)),
  // 批量配置学生
  BatchStudentSetting: (params) => InterfaceHttp(ajax.post('/data/v1/GroupReportCourse/BatchStudentSetting', params)),
  // 团体报告重新算分
  GroupReportUpdateCourseContentScore: (params) => InterfaceHttp(ajax.post('/coursecenter/v1/ContentScore/GroupReportUpdateCourseContentScore', params)),

  //添加报告-根据id获取团体报告信息
  getModel: (params) => InterfaceHttp(ajax.get('/data/v1/groupreport/getmodel', { params })),
  //添加报告-获取项目配置
  getGroupReportCourse: (params) => InterfaceHttp(ajax.get('/data/v1/GroupReportCourse/GetGroupReportCourse', { params })),
  //添加报告-添加课程
  addCourseChild: (params) => InterfaceHttp(ajax.post('/data/v1/GroupReportCourse/add', params)),
  //添加报告-清空机构团体报告课程配置信息
  deleteOrgGroupReportCourse: (params) => InterfaceHttp(ajax.post('/data/v1/GroupReportCourse/deleteOrgGroupReportCourse', params)),

  //添加报告-获取对比样本列表
  getListByGroupReport: (params) => InterfaceHttp(ajax.get('/data/v1/GroupReportSample/GetListByGroupReportId', { params })),

  //添加报告-配置用户-学生列表
  getCourseChildUserList: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/UserChildCourse/GroupReportUserCourseChildConfigPageList', { params })),

  //删除对比样本getReportTemplate
  delSample: (params) => InterfaceHttp(ajax.post('/data/v1/GroupReportSample/delete', params)),

  // 修改报告状态
  updateStatus: (params) => InterfaceHttp(ajax.post('/data/v1/GroupReport/updatestatus', params)),
  // 重新生成报告
  generateGroupReportById: (params) => InterfaceHttp(ajax.post('/data/v1/GroupReport/GenerateGroupReportById', params)),
  // 拷贝报告
  copyGroupReport: (params) => InterfaceHttp(ajax.post('/data/v1/groupreport/copygroupreport', params)),
  // 替换报告
  replaceReport: (params) => InterfaceHttp(ajax.post('/data/v1/groupreport/replace', params)),

  // 个人报告列表
  personalReportPageList: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/PersonalCombinationReports', { params })),
  // 新增修改个人报告
  editPersonalReport: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/PersonalCombinationReports/Edit', params)),
  // 删除个人报告
  deletePersonalReport: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/PersonalCombinationReports/DeleteAsync', params)),
  // 根据id获取报告信息
  getPersonalReportModel: (params) => InterfaceHttp(ajax.get(`/2b/coursecenter/v1/PersonalCombinationReports/${params.id}`, { params })),
  // 个人报告新增课程
  addCourse: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/PersonalCombinationReportCourses', params)),
  // 个人报告删除课程
  deleteCourse: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/PersonalCombinationReportCourses/DeleteAsync', params)),
  // 个人报告已添加课程列表
  addCourseList: (params) => InterfaceHttp(ajax.get(`/2b/coursecenter/v1/PersonalCombinationReportCourses/${params.combinationReportId}`, { params })),
  // 添加课程列表
  GetPersonalCombinationReportCoursePageList: (params) => InterfaceHttp(ajax.get(`/2b/coursecenter/v1/PersonalCombinationReportCourses/${params.organizationId}/${params.reportConfigId}`, { params })),
  // 个人报告 年级班级数结构
  projectcoursegradeclasstree: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/PersonalCombinationReportCourses/GetCombinationReportGradeClassTree?' + serializeData(params))),
  // 个人报告配置学生 学生列表
  GetPersonalCombinationReportUserPageList: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/UserCourse/GetPersonalCombinationReportUserPageList?' + serializeData(params))),
  // 个人报告 添加学生
  editPersonalStudent: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/PersonalCombinationReportStudent/Edit', params)),
  // 修改状态
  UpdateStatus: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/PersonalCombinationReportConfig/UpdateStatus', params)),
  generateReport: (params) => InterfaceHttp(ajax.post(`/report/v1/user-course-reports/generate-combination-report`, params)),
  // 修改状态
  scoreSwitchEdit: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/PersonalCombinationReportCourses/EditAbilities', params)),
  // 获取课程下任务
  getCourseAbilityConfigs: (params) => InterfaceHttp(ajax.get(`/2b/coursecenter/v1/PersonalCombinationReportCourses/AbilityConfigs/${params.combinationReportId}/${params.organizationCourseId}`)),
  // 组合报告选择考试列表
  getExaminationList: (params) => InterfaceHttp(ajax.get('/data/v1/subjectscoreuploadrecord/pagelist', { params })),
  // 组合报告选择考试列表学科下拉
  extsubject: (params) => InterfaceHttp(ajax.get('/data/v1/learningmanage/extsubject', { params })),
}
/**
 *  通用接口
 *
 * */
export const CommonInterface = {
  // 获取班级年级树结构数据
  getGradeClass: (params) => InterfaceHttp(ajax.get('/user/v1/OrganizationStructure/GetAuthorizeGradeClassSelectOptions', { params })),

  //获取能力
  getAbility: (params) => InterfaceHttp(ajax.get('/content/v1/ability/loadall', { params })),

  //获取所有平台用户
  getAllPrincipal: (params) => InterfaceHttp(ajax.get('/user/v1/Admin/getAllPrincipal', { params })),

  //获取五大能力
  getAllLoadallsel: (params) => InterfaceHttp(ajax.get('/content/v1/ability/loadallsel', { params })),
}

/* 课程管理 -- 资源列表 */
export const resourcesList = {
  // 阿里云上传
  CreateUploadVideo: (params) => InterfaceHttp(ajax.post('/file/v1/video/CreateUploadVideo', params)),
  RefreshUploadVideo: (params) => InterfaceHttp(ajax.get('/file/v1/video/RefreshUploadVideo' + params)),

  // 获取RAM角色的临时身份凭证
  GetAcsResponse: (params) => InterfaceHttp(ajax.post('/file/v1/File/GetAcsResponse', params)),
  // 获取资源下载权限
  getResourceDownloadAuthority: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/OrganizationCourseMaterialConfig/GetOrganizationCourseMaterialConfigDetails', params)),
  // 配置资源，编辑教学资源查看状态
  materialConfigStatus: (params) => InterfaceHttp(ajax.post('/2b/coursecenter/v1/OrganizationCourseMaterialConfig/UpdateOrganizationCourseMaterialConfigStatus', params)),
  // 文档文件预览
  GeneratePresignedUri: (params) => InterfaceHttp(ajax.get('/content/v1/FileResource/GeneratePresignedUri', { params })),
}

/* 运营中心 */
export const operate = {
  //订单管理列表
  GetOrderPageList: (params) => InterfaceHttp(ajax.get('/2c/coursecenter/v1/Order/GetOrderPageList', { params })),
  //订单管理刷新订单
  RefreshOrder: (params) => InterfaceHttp(ajax.post('/2c/coursecenter/v1/Order/RefreshOrder', params)),
  //修改订单手机号
  UpdateOrderPhone: (params) => InterfaceHttp(ajax.post('/2c/coursecenter/v1/Order/UpdateOrderPhone', params)),
  //订单详情修改手机号
  UpdateOrderCourseMobile: (params) => InterfaceHttp(ajax.post('/2c/coursecenter/v1/Order/UpdateOrderCourseMobile', params)),
  //订单详情手机号变更记录
  GetChangeRecord: (params) => InterfaceHttp(ajax.post('/2c/coursecenter/v1/Order/GetChangeRecord?' + serializeData(params))),
  //1、订单详情列表 2、用户详情课程内容
  GetUserCoursePageList: (params) => InterfaceHttp(ajax.get('/2c/coursecenter/v1/UserCourse/GetUserCoursePageList', { params })),

  // 用户管理列表
  GetUserPageList: (params) => InterfaceHttp(ajax.get('/2c/coursecenter/v1/Order/GetUserPageList', { params })),
  // 用户详情信息
  GetUserByAccountId: (params) => InterfaceHttp(ajax.get('/user/v1/UserRegister/GetUserByAccountId?' + serializeData(params))),
  // 用户详情标签和备注
  EditAccount: (params) => InterfaceHttp(ajax.post('/user/v1/User/EditAccount', params)),
  // 用户详情统计信息
  GetUserOrderSummary: (params) => InterfaceHttp(ajax.get('/2c/coursecenter/v1/Order/GetUserOrderSummary', { params })),

  // 商品管理列表
  GetSpuPageList: (params) => InterfaceHttp(ajax.get('/2c/coursecenter/v1/SPu/GetSpuPageList', { params })),
  // 商品详情列表
  GetSkuPageList: (params) => InterfaceHttp(ajax.get('/2c/coursecenter/v1/SKu/GetSkuPageList', { params })),
  // 商品管理列表刷新数据
  RefreshSpu: (params) => InterfaceHttp(ajax.post('/2c/coursecenter/v1/SPu/RefreshSpu', params)),
  // 商品详情选择课程下拉列表
  GetSkuBindCourseList: (params) => InterfaceHttp(ajax.get('/2c/coursecenter/v1/SKu/GetSkuBindCourseList', { params })),
  // 商品详情绑定取消绑定
  sKuEdit: (params) => InterfaceHttp(ajax.post('/2c/coursecenter/v1/SKu/edit', params)),

  // 免费测评、体验课配置列表
  GetGroupPageList: (params) => InterfaceHttp(ajax.get('/2c/coursecenter/v1/CourseConfigGroup/GetGroupPageList', { params })),
  // 获取详情
  GetGroupDetail: (params) => InterfaceHttp(ajax.get('/2c/coursecenter/v1/CourseConfigGroup/GetGroupDetail', { params })),
  // 添加编辑基本设置、体验课配置添加编辑系列
  EditCourseConfigGroup: (params) => InterfaceHttp(ajax.post('/2c/coursecenter/v1/CourseConfigGroup/EditCourseConfigGroup', params)),
  // 免费测评 内容配置
  GetGroupCoursePageList: (params) => InterfaceHttp(ajax.get('/2c/coursecenter/v1/CourseConfig/GetGroupCoursePageList', { params })),
  // 内容配置删除课程
  DeleteCourse: (params) => InterfaceHttp(ajax.post('/2c/coursecenter/v1/CourseConfig/Delete', params)),
  // 删除
  DeleteGroup: (params) => InterfaceHttp(ajax.post('/2c/coursecenter/v1/CourseConfigGroup/Delete', params)),
  // 修改状态
  UpdateStatus: (params) => InterfaceHttp(ajax.post('/2c/coursecenter/v1/CourseConfigGroup/UpdateStatus', params)),
  // 免费测评添加资源获取系列及课程
  GetCourseSeriesPageList: (params) => InterfaceHttp(ajax.get('/2c/coursecenter/v1/CourseConfig/GetCourseSeriesPageList', { params })),
  // 添加课程
  GroupAddCourse: (params) => InterfaceHttp(ajax.post('/2c/coursecenter/v1/CourseConfig/GroupAddCourse', params)),
  //体验课添加课程列表
  GetCourseResoursePageList: (params) => InterfaceHttp(ajax.get('/2c/coursecenter/v1/CourseConfig/GetCourseResoursePageList', { params })),
  //体验课获取系列下课程
  GetGroupCourseDetailPageList: (params) => InterfaceHttp(ajax.get('/2c/coursecenter/v1/CourseConfig/GetGroupCourseDetailPageList', { params })),
  //体验课修改课程状态
  courseStatusChange: (params) => InterfaceHttp(ajax.post('/2c/coursecenter/v1/CourseConfig/UpdateStatus', params)),
  // 获取课时配置
  GetChildCourseConfigPageList: (params) => InterfaceHttp(ajax.get('/2c/coursecenter/v1/ChildCourseConfig/GetChildCourseConfigPageList', { params })),
  // 修改课时状态
  UpdateRuleType: (params) => InterfaceHttp(ajax.post('/2c/coursecenter/v1/ChildCourseConfig/UpdateRuleType', params)),
}

/* 渠道管理 */
export const Channel = {
  // 获取所有渠道分页列表
  getChannelPageList: (params) => InterfaceHttp(ajax.get('/2c/coursecenter/v1/Channel/GetChannelPageList', { params })),

  // 添加渠道
  addChannel: (params) => InterfaceHttp(ajax.post('/2c/coursecenter/v1/Channel/add', params)),

  // 修改渠道名称
  updateChannel: (params) => InterfaceHttp(ajax.post('/2c/coursecenter/v1/Channel/update', params)),

  // 获取免费测评参与用户分页列表
  getFreeGroupPageList: (params) => InterfaceHttp(ajax.get('/2c/coursecenter/v1/CourseConfig/GetFreeGroupPageList', { params })),

  // 获取项目下渠道分页列表
  getGroupChannelPageList: (params) => InterfaceHttp(ajax.get('/2c/coursecenter/v1/CourseGroupChannel/GetGroupChannelPageList', { params })),

  // 获取免费测评参与用户分页列表
  updateChannelStatus: (params) => InterfaceHttp(ajax.post('/2c/coursecenter/v1/CourseGroupChannel/UpdateChannelStatus', params)),

  // 获取免费测评参与用户分页列表
  getExperienceCoursePageList: (params) => InterfaceHttp(ajax.get('/2c/coursecenter/v1/CourseConfig/GetExperienceCoursePageList', { params })),
}

/* 首页/内容中心/课程管理/内容列表/全局推荐*/
export const GlobalContent = {
  // 删除全局推荐分页列表
  deleteCourseSeriesItemConfig: (params) => InterfaceHttp(ajax.post('/content/v1/ChildCourseItemConfig/DeleteCourseSeriesItemConfig', params)),
  // 获取查看列表
  getItemConfigChildCoursePageList: (params) => InterfaceHttp(ajax.get('/content/v1/ChildCourseItemConfig/GetItemConfigChildCoursePageList', { params })),
  // 查看列表删除
  deleteconfig: (params) => InterfaceHttp(ajax.post('/content/v1/ChildCourseItemConfig/deleteconfig', params)),
}

export const FileResource = {
  // pagelist: params => InterfaceHttp(ajax.get('/content/v1/FileResource/GetPageList',  {params})),
  pagelist: (params) => InterfaceHttp(ajax.get('/content/v1/FileResource/GetPageList?' + serializeData(params))),
  add: (params) => InterfaceHttp(ajax.post('/content/v1/FileResource/add', params)),
  update: (params) => InterfaceHttp(ajax.post('/content/v1/FileResource/update', params)),
  delete: (params) => InterfaceHttp(ajax.post('/content/v1/FileResource/delete', params)),
  batchRove: (params) => InterfaceHttp(ajax.post('/content/v1/FileResource/BatchRove', params)),
  deleteVideo: (params) => InterfaceHttp(ajax.post('/file/v1/video/deleteVideo', params)),
  getVideoPlayAuth: (params) => InterfaceHttp(ajax.get('/content/v1/FileResource/GetVideoPlayAuth', { params })),
}

export const User = {
  checkSubProductService: (params) => InterfaceHttp(ajax.get(`/user/v1/Organization/SubProductService`, { params })),
  getUserAndCourseStatistics: (params) => InterfaceHttp(ajax.get('/data/v1/AreaDataBoard/GetUserAndCourseStatistics?' + serializeData(params)), {}),

  // 获取最近访问的菜单
  getWorkbenchData: (params) => InterfaceHttp(ajax.get('/user/v1/Workbench/WorkbenchData', { params })),

  // 获取系统公告
  getSysNotice: (params) => InterfaceHttp(ajax.get('/data/v1/Workbench/SysNoticePageList', { params })),

  // 检查是否拥有机构权限
  checkOrganizationAuth: (params) => InterfaceHttp(ajax.get('/user/v1/Organization/CheckDataAuth', { params })),

  // 全国大基本信息
  getAreaUserSummary: (params) => InterfaceHttp(ajax.get('/user/v1/data-statistics/platform-overview', { params })),

  // 获取系统所有学生列表
  getOrganizationUserPageList: (params) => InterfaceHttp(ajax.get('/user/v1/OrganizationUser/OrganizationUserPageList', { params })),
  getOnlineCount: (params) => InterfaceHttp(ajax.get('/user/v1/online-status/online-count', { params })),
}

export const CourseCenter = {
  // 导出课程数据接口
  getUserCourseAbilityScoreData: (params) => InterfaceHttp(ajax.get('/coursecenter/v1/UserCourse/GetUserCourseAbilityScoreData?' + serializeData(params))),

  // 常模重算粗分
  updateContentStandardScore: (params) => InterfaceHttp(ajax.post('/coursecenter/v1/ContentScore/UpdateContentStandardScore', params)),
  UpdateContentOriginalScore: (params) => InterfaceHttp(ajax.post('/coursecenter/v1/ContentScore/UpdateContentOriginalScore', params)),
  // 课程内容重新算分 课程管理-重新算分
  updateCourseContentScores: (params) => InterfaceHttp(ajax.post('/coursecenter/v1/ContentScore/UpdateCourseContentScores', params)),

  // 学生详情-获取评价
  getUserEvaluation: (params) => InterfaceHttp(ajax.get('/coursecenter/v1/UserChildCourseEvaluation/GetUserEvaluation', { params })),

  // 学生详情 - 教师评价题目壳数据提交
  saveEvaluation: (params) => InterfaceHttp(ajax.post('/coursecenter/v1/UserChildCourseEvaluation/SaveEvaluation', params)),
}

export const TwoB = {
  // 机构营销数据分析接口
  getOrganizationMarketData: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/ProjectCourseResource/GetOrganizationMarketData', { params })),

  // 获取系统所有接口
  getCoursePageList: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/ProjectCourseConfig/getPageList', { params })),

  // 获取课程所有内容 课程管理-重新算分
  getCustomerCourseEvaluationContents: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/UserChildCourseContentSnapshot/GetCustomerCourseEvaluationContents?' + serializeData(params))),
}

export const Data = {
  // 获取活跃人数统计
  getActivationStatistics: (params) => InterfaceHttp(ajax.get('/data/v1/Workbench/ActivationStatistics', { params })),

  // 获取平台大屏排名
  getCountryBoardData: (params) => InterfaceHttp(ajax.get('/data/v1/AreaDataBoard/GetCountryBoardData', { params })),

  DisableNotice: (params) => InterfaceHttp(ajax.post(`/data/v1/Notice/DisableNotice`, params)),
}

export const Content = {
  getCourseContentNorms: (params) => InterfaceHttp(ajax.get('/content/v1/Norm/contentNormList?' + serializeData(params))),
  normDelete: (params) => InterfaceHttp(ajax.post('/content/v1/Norm/Delete', params)),

  GetFileResourceIncidenceList: (params) => InterfaceHttp(ajax.get('/content/v1/FileResource/GetFileResourceIncidenceList', { params })),
}

export const Base = {
  // 获取已配置的回复
  GetGetWechatCustommessageByType: (params) => InterfaceHttp(ajax.get('/base/v1/WechatCustommessage/GetGetWechatCustommessageByType', { params })),
  // 添加编辑回复
  editCustommessage: (params) => InterfaceHttp(ajax.post('/base/v1/WechatCustommessage/Edit', params)),
  // 删除回复
  deleteCustommessage: (params) => InterfaceHttp(ajax.post('/base/v1/WechatCustommessage/Delete', params)),

  // 自动回复开启关闭
  updateEnabled: (params) => InterfaceHttp(ajax.post('/base/v1/WechatCustommessage/UpdateEnabled', params)),

  // 获取公众号媒体资源
  getOthersMediaList: (params) => InterfaceHttp(ajax.get('/base/v1/wechat/media/GetOthersMediaList', { params })),

  // 获取公众号自定义菜单
  getMenu: (params) => InterfaceHttp(ajax.get('/base/v1/wechat/Menu', { params })),

  // 获取公众号自定义菜单
  menuCreate: (params) => InterfaceHttp(ajax.post('/base/v1/wechat/Menu/create', params)),

  // 获取公众号媒体内容
  getForeverVideo: (params) => InterfaceHttp(ajax.get('/base/v1/wechat/media/GetForeverVideo', { params })),

  // 获取参数配置
  getModelByKey: (params) => InterfaceHttp(ajax.get(`/base/v1/DictionaryParameter/GetModelByKey`, { params })),
}

// 游戏分析
export const GameAnalysis = {
  // 游戏分析筛选
  getOverview: (params) => InterfaceHttp(ajax.get('/data/v1/magicMirror/getOverView', { params })),
  // 游戏分析 综合分析
  getComprehensiveStatisticsPageList: (params) => InterfaceHttp(ajax.get('/data/v1/MagicMirror/ComprehensiveStatisticsPageList', { params })),
  // 游戏分析 留存率
  getRetentionPageList: (params) => InterfaceHttp(ajax.get('/data/v1/MagicMirror/RetentionPageList', { params })),
}

// 游戏评价
export const GamesComment = {
  // 评价记录列表
  getEvaluateSummaryList: (params) => InterfaceHttp(ajax.get('/content/v1/EvaluateSummary/getPageList', { params })),
  // 评价记录查看记录
  getViewEvaluateSummaryList: (params) => InterfaceHttp(ajax.get('/content/v1/EvaluateSummary/getEvaluationPageList', { params })),
  // 评价记录查看记录 获取题目下拉
  getAllTopic: (params) => InterfaceHttp(ajax.get('/content/v1/EvaluationTopic/getAllTopic', { params })),

  // 题目列表
  getTopicPageList: (params) => InterfaceHttp(ajax.get('/content/v1/EvaluationTopic/getPageList', { params })),
  // 题目列表 添加
  addTopic: (params) => InterfaceHttp(ajax.post('/content/v1/EvaluationTopic/add', params)),
  // 题目列表 编辑
  editTopic: (params) => InterfaceHttp(ajax.post('/content/v1/EvaluationTopic/edit', params)),
  // 题目列表 删除
  deleteTopic: (params) => InterfaceHttp(ajax.post('/content/v1/EvaluationTopic/delete', params)),
  // 题目列表 更新状态
  updataStatusTopic: (params) => InterfaceHttp(ajax.post('/content/v1/EvaluationTopic/updataStatus', params)),
  // 题目列表 详情
  topicDetail: (params) => InterfaceHttp(ajax.get('/content/v1/EvaluationTopic/detail', { params })),
  // 题目列表 关联游戏
  getAllContentByType: (params) => InterfaceHttp(ajax.get('/content/v1/content/getAllContentByType?' + serializeData(params))),

  // 黑名单列表
  getBlacklist: (params) => InterfaceHttp(ajax.get('/coursecenter/v1/EvaluateBlacklist/getPageList', { params })),
  // 添加黑名单
  addBlacklist: (params) => InterfaceHttp(ajax.post('/content/v1/EvaluateBlacklist/add', params)),
  // 编辑黑名单
  editBlacklist: (params) => InterfaceHttp(ajax.post('/content/v1/EvaluateBlacklist/edit', params)),
  // 删除黑名单
  deleteBlacklist: (params) => InterfaceHttp(ajax.post('/content/v1/EvaluateBlacklist/delete', params)),
  // 黑名单获取课程
  getCourseConfigList: (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/ProjectCourseConfig/getPageList?' + serializeData(params))),
}

// 脑机配置
export const Brain = {
  // 获取脑机设备列表
  getBrainMachineList: (params, version = '1.0') => InterfaceHttp(ajax.get('/base/v1/Device/PageList', { params: { ...params, Version: version } })),
  // 获取脑机设备列表详情
  getModel: (params) => InterfaceHttp(ajax.get('/base/v1/Device/GetModel', { params })),
  // 添加脑机设备
  addDevice: (params) => InterfaceHttp(ajax.post('/base/v1/Device/AddDevice', params)),
  // 删除脑机设备
  deleteDevice: (params) => InterfaceHttp(ajax.post('/base/v1/Device/DeleteDevice', params)),
  // 编辑脑机设备
  editDevice: (params) => InterfaceHttp(ajax.post('/base/v1/Device/EditDevice', params)),
  // 批量导入
  importDeviceData: (params, version = '1.0') => {
    params.append('Version', version)
    return InterfaceHttp(ajax.post('/base/v1/Device/ImportDeviceData', params))
  },

  // 设备类型列表
  getBrainGamesList: (params, brainVersion = '1.0') => InterfaceHttp(ajax.get('/content/v1/BrainMachineContent/PageList', { params: { ...params, brainVersion } })),
  // 设备类型 添加编辑
  brainGamesEdit: (params, brainVersion = '1.0') => InterfaceHttp(ajax.post('/content/v1/BrainMachineContent/edit', { ...params, brainVersion })),
  // 设备类型修改状态
  UpdateStatus: (params) => InterfaceHttp(ajax.post('/content/v1/BrainMachineContent/UpdateStatus', params)),
  // 删除脑机游戏
  deleteBrainGames: (params) => InterfaceHttp(ajax.post('/content/v1/BrainMachineContent/delete', params)),
}
/// 教师资源
export const TResource = {
  getPageList: (params = {}, str = '') => InterfaceHttp(ajax.get('/content/v1/ResourcePackage/pagelist' + str, { params })),
  getDetail: (params = {}) => InterfaceHttp(ajax.get('/content/v1/BrainMachineContent/UpdateStatus', params)),
}

export const ParamsApi = {
  getPageList: (params) => InterfaceHttp(ajax.get('/base/v1/DictionaryParameter/pagelist', { params })),
  editRecord: (params) => InterfaceHttp(ajax.post('/base/v1/DictionaryParameter/Edit', params)),
  deleteRecord: (params) => InterfaceHttp(ajax.post('/base/v1/DictionaryParameter/Delete', params)),
}

export const File = {
  upload: (url, params) => InterfaceHttp(ajax.post(url, params)),
}

// 课程资源服务
export const CourseResource = {
  classificationsGet: (params) => InterfaceHttp(ajax.get('/courseResource/v1/classifications', { params })),
  classificationsAdd: (params) => InterfaceHttp(ajax.post('/courseResource/v1/classifications', params)),
  classificationsEdit: (id, params) => InterfaceHttp(ajax.put(`/courseResource/v1/classifications/${id}`, params)),
  classificationsDelete: (id) => InterfaceHttp(ajax.delete(`/courseResource/v1/classifications/${id}`)),
  classificationsSort: (params) => InterfaceHttp(ajax.put(`/courseResource/v1/classifications/sort`, params)),
  seriesGet: (params) => InterfaceHttp(ajax.get(`/courseResource/v1/series?` + serializeData(params))),
  seriesEnabled: (id, params) => InterfaceHttp(ajax.put(`/courseResource/v1/series/${id}/enabled`, params)),
  seriesDelete: (id) => InterfaceHttp(ajax.delete(`/courseResource/v1/series/${id}`)),
  seriesEdit: (id, params) => InterfaceHttp(ajax.put(`/courseResource/v1/series/${id}`, params)),
  seriesAdd: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/series/add`, params)),
  seriesStatus: (id, params) => InterfaceHttp(ajax.put(`/courseResource/v1/series/${id}/status`, params)),
  serieContents: (params) => InterfaceHttp(ajax.get(`/courseResource/v1/series/serie-contents`, { params })),
  serieItems: (params) => InterfaceHttp(ajax.get(`/courseResource/v1/series/serie-items?` + serializeData(params))),
  ResourcePackageGet: (id) => InterfaceHttp(ajax.get(`/courseResource/v1/resourcePackage/${id}`)),
  ResourcePackageEnabled: (id, params) => InterfaceHttp(ajax.put(`/courseResource/v1/resourcePackage/${id}/enabled`, params)),
  ResourcePackageDelete: (id) => InterfaceHttp(ajax.delete(`/courseResource/v1/resourcePackage/${id}`)),
  AddResourcePackage: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/resourcePackage/AddResourcePackage`, params)),
  EditResourcePackage: (params) => InterfaceHttp(ajax.put(`/courseResource/v1/resourcePackage/EditResourcePackage`, params)),
  RemovePackage: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/resourcePackage/RemovePackage`, params)),
  ImportPackage: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/resourcePackage/ImportPackage`, params)),
  ResourcePackagePagelist: (params) => InterfaceHttp(ajax.get(`/courseResource/v1/resourcePackage/pagelist?` + serializeData(params))),

  CourseReportsList: (params) => InterfaceHttp(ajax.get(`/courseResource/v1/CourseReports?` + serializeData(params))),
  CourseReportsAdd: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/CourseReports`, params)),
  CourseReportsEdit: (params) => InterfaceHttp(ajax.put(`/courseResource/v1/CourseReports`, params)),
  CourseReportsDelete: (id) => InterfaceHttp(ajax.delete(`/courseResource/v1/CourseReports/${id}`)),

  // 获取系列下所有课程
  courseAll: (params) => InterfaceHttp(ajax.get('/courseResource/v1/course/all', { params })),
  courseList: (params) => InterfaceHttp(ajax.get('/courseResource/v1/course?' + serializeData(params))),
  courseDetail: (params) => InterfaceHttp(ajax.get(`/courseResource/v1/course/${params}`)),
  courseCopy: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/course/copy`, params)),
  courseAdd: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/course`, params)),
  courseUpdate: (params) => InterfaceHttp(ajax.put(`/courseResource/v1/course`, params)),
  courseDelete: (params) => InterfaceHttp(ajax.delete(`/courseResource/v1/course/${params}`)),
  courseImport: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/course/import`, params)),

  //课时资源
  getCourseSessions: (params) => InterfaceHttp(ajax.get('/courseResource/v1/course-sessions', { params })),
  courseSessionAdd: (params) => InterfaceHttp(ajax.post('/courseResource/v1/course-sessions', params)),
  courseSessionUpdate: (params) => InterfaceHttp(ajax.put('/courseResource/v1/course-sessions', params)),
  courseSessionResetName: (params) => InterfaceHttp(ajax.patch('/courseResource/v1/course-sessions/reset-names', params)),
  courseSessionCopy: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/course-sessions/copy`, params)),
  courseSessionStatus: (params) => InterfaceHttp(ajax.patch(`/courseResource/v1/course-sessions/status`, params)),
  courseSessionDelete: (params) => InterfaceHttp(ajax.delete(`/courseResource/v1/course-sessions/${params}`)),
  courseSessionDetails: (params) => InterfaceHttp(ajax.get(`/courseResource/v1/course-sessions/${params}`)),
  courseSessionSerie: (params) => InterfaceHttp(ajax.get(`/courseResource/v1/course-sessions/serie-sessions`, { params })),
  courseSessionSetCount: (params) => InterfaceHttp(ajax.patch(`/courseResource/v1/course-sessions/batch-set-content-count`, params)),
  courseSessionImportEvaluations: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/course-sessions/import-evaluations`, params)),

  contentListSerie: (params) => InterfaceHttp(ajax.get('/courseResource/v1/course-session-contents/serie-contents?' + serializeData(params))),
  contentList: (params) => InterfaceHttp(ajax.get(`/courseResource/v1/course-session-contents`, { params })),
  contentAdd: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/course-session-contents`, params)),
  contentUpdate: (params) => InterfaceHttp(ajax.put(`/courseResource/v1/course-session-contents`, params)),
  contentDelete: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/course-session-contents/delete`, params)),
  contentRegular: (params) => InterfaceHttp(ajax.patch(`/courseResource/v1/course-session-contents/regular`, params)),
  contentEcutionTimes: (params) => InterfaceHttp(ajax.patch(`/courseResource/v1/course-session-contents/ecution-times`, params)),
  contentDisplayOrder: (params) => InterfaceHttp(ajax.patch(`/courseResource/v1/course-session-contents/display-order`, params)),
  contentLinkVedio: (params) => InterfaceHttp(ajax.patch(`/courseResource/v1/course-session-contents/link-vedio`, params)),
  contentScoreSetting: (params) => InterfaceHttp(ajax.put(`/courseResource/v1/course-session-contents/calculate-score-setting`, params)),
  contentReplace: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/course-session-contents/replace`, params)),

  courseMaterialList: (params) => InterfaceHttp(ajax.get(`/courseResource/v1/course-materials`, { params })),
  courseMaterialAdd: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/course-materials`, params)),
  courseMaterialDelete: (params) => InterfaceHttp(ajax.delete(`/courseResource/v1/course-materials/${params}`)),
  courseMaterialRename: (params) => InterfaceHttp(ajax.put(`/courseResource/v1/course-materials/rename`, params)),
  courseMaterialFile: (params) => InterfaceHttp(ajax.get(`/courseResource/v1/course-materials/file-resource-relevancy-courses`, { params })),

  resourcePackageDetailsRelevancy: (params) => InterfaceHttp(ajax.get(`/courseResource/v1/resource-package-details/file-resource-relevancy-packages`, { params })),

  getPagelistPackage: (params) => InterfaceHttp(ajax.get(`/courseResource/v1/resource-package-details/pagelist`, { params })),
  getTreeMenu: (params) => InterfaceHttp(ajax.get(`/courseResource/v1/resource-package-details/GetTreeMenu`, { params })),
  changeDownload: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/resource-package-details/UpdateDownloadAuthority`, params)),
  editpkName: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/resource-package-details/reName`, params)),
  addPackage: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/resource-package-details/add`, params)),
  deletePackage: (params) => InterfaceHttp(ajax.post('/courseResource/v1/resource-package-details/delete', params)),
  batchModify: (params) => InterfaceHttp(ajax.post('/courseResource/v1/resource-package-details/BatchModify', params)),
  // 体验内容
  getExperienceList: (params) => InterfaceHttp(ajax.get(`/courseResource/v1/course-experience-content`, { params })),
  addExperienceList: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/course-experience-content`, params)),
  pinExperienceList: (params) => InterfaceHttp(ajax.post(`/courseResource/v1/course-experience-content/pin`, params)),
  delExperienceList: (params) => InterfaceHttp(ajax.delete(`/courseResource/v1/course-experience-content?${serializeData(params)}`)),
  settingRecommendRule: (params) => InterfaceHttp(ajax.put(`/courseResource/v1/course/recommend-rule`, params)),
  checkSeriesExperience: (params) => InterfaceHttp(ajax.get(`/courseResource/v1/series/check-intelligent-course-child`, { params })),
  checkRemoveExperience: (params) => InterfaceHttp(ajax.get(`/courseResource/v1/course-experience-content/check-formal-content`, { params })),
  updateCourseExperience: (params) => InterfaceHttp(ajax.put(`/courseResource/v1/course-experience-content`, params)),
  updateDisplayOlder: (params) => InterfaceHttp(ajax.patch(`/courseResource/v1/course-sessions/display-order`, params)),
}
export const CourseService = {
  ResourcePackageUsages: (params) => InterfaceHttp(ajax.get(`/course/v1/organization/resource-rackages/resource-package-usages?` + serializeData(params))),
  getResourseListByOrg: (params) => InterfaceHttp(ajax.get('/course/v1/organization/resource-rackages', { params })),
  getResourseById: (id) => InterfaceHttp(ajax.get(`/course/v1/organization/resource-rackages/${id}`)),
  resourseBatchEdit: (params) => InterfaceHttp(ajax.post(`/course/v1/organization/resource-rackages/batch-edit`, params)),
  resourseBatchDel: (params) => InterfaceHttp(ajax.post(`/course/v1/organization/resource-rackages/batch-delete`, params)),
  getResourseListAllByOrg: (organizationId) => InterfaceHttp(ajax.get(`/course/v1/organization/${organizationId}/resource-rackages`)),
  resourseUpdateDown: (params) => InterfaceHttp(ajax.post(`/course/v1/organization/resource-rackages/update-resource-downloadable`, params)),
  getResourseListUsage: (params) => InterfaceHttp(ajax.get(`/course/v1/organization/resource-rackages/resource-usage-details?${serializeData(params)}`)),
  organizations: (id, params) => InterfaceHttp(ajax.get(`/course/v1/organization/resource-rackages/${id}/organizations`, { params })),
  getCourseResources: (params) => InterfaceHttp(ajax.get(`/course/v1/organization/course-resources?${serializeData(params)}`)),
  addCoursePackage: (params, customConfig) => InterfaceHttp(ajax.post(`/course/v1/organization/course-resources`, params), customConfig),
  editCoursePackage: (params, customConfig) => InterfaceHttp(ajax.put(`/course/v1/organization/course-resources`, params), customConfig),
  delCoursePackage: (id) => InterfaceHttp(ajax.delete(`/course/v1/organization/course-rackages/${id}`)),
  getCourseListByPackage: (params) => InterfaceHttp(ajax.get(`/course/v1/organization/course-rackages`, { params })),

  checkCourseReport: (id) => InterfaceHttp(ajax.post(`/course/v1/organization/course-resources/check-course-report/${id}`)),
  getOrganizationCourseDetails: (id) => InterfaceHttp(ajax.get(`/course/v1/OrganizationCourse/${id}`)),

  getCourseNorm: (id) => InterfaceHttp(ajax.get(`/course/v1/course-norm/${id}`)),
  submitCourseNorm: (params) => InterfaceHttp(ajax.post(`/course/v1/course-norm`, params)),

  // 删除课程资源
  deleteCourseResources: (params) => InterfaceHttp(ajax.delete(`/course/v1/organization/course-resources`, { params })),

  OrganizationCourseList: (params) => InterfaceHttp(ajax.get(`/course/v1/OrganizationCourse`, {params})),
}

export const ReportService = {
  // 能力评价列表
  getAbilitylevelReference: (params) => InterfaceHttp(ajax.get(`/report/v1/AbilitylevelReference`, { params })),
  // 添加能力评价
  addAbilitylevelReference: (params) => InterfaceHttp(ajax.post(`/report/v1/AbilitylevelReference`, params)),
  // 能力评价修改
  upateAbilitylevelReference: (params) => InterfaceHttp(ajax.put(`/report/v1/AbilitylevelReference`, params)),
  // 能力评价删除
  deleteAbilitylevelReference: (id) => InterfaceHttp(ajax.delete(`/report/v1/AbilitylevelReference/${id}`)),
  // 能力评价状态更新
  statusAbilitylevelReference: (id) => InterfaceHttp(ajax.post(`/report/v1/AbilitylevelReference/${id}/status`)),

  // 评价体系列表
  getAbilityEvaluationSys: (params) => InterfaceHttp(ajax.get(`/report/v1/AbilityEvaluationSys`, { params })),
  // 评价体系新增
  addAbilityEvaluationSys: (params) => InterfaceHttp(ajax.post(`/report/v1/AbilityEvaluationSys`, params)),
  // 评价体系修改
  updateAbilityEvaluationSys: (params) => InterfaceHttp(ajax.put(`/report/v1/AbilityEvaluationSys/${params.get('id')}/update`, params)),
  // 评价体系状态
  statusAbilityEvaluationSys: (id) => InterfaceHttp(ajax.post(`/report/v1/AbilityEvaluationSys/${id}/updatestatus`)),
  // 评价体删除
  deleteAbilityEvaluationSys: (id) => InterfaceHttp(ajax.delete(`/report/v1/AbilityEvaluationSys/${id}`)),
  // 评价等级与类型
  getinforbysysid: (id) => InterfaceHttp(ajax.get(`/report/v1/AbilityEvaluationSys/getinforbysysid/${id}`)),

  // 获取评价类型
  getAbilitylevelReferencetype: (params) => InterfaceHttp(ajax.get(`/report/v1/AbilitylevelReferencetype`, { params })),
  // 新增评价类型
  addAbilitylevelReferencetype: (params) => InterfaceHttp(ajax.post(`/report/v1/AbilitylevelReferencetype`, params)),
  // 修改评价类型
  updateAbilitylevelReferencetype: (params) => InterfaceHttp(ajax.put(`/report/v1/AbilitylevelReferencetype`, params)),
  // 修改评价类型状态
  statusAbilitylevelReferencetype: (id) => InterfaceHttp(ajax.post(`/report/v1/AbilitylevelReferencetype/${id}/status`)),
  // 删除评价类型
  deleteAbilitylevelReferencetype: (id) => InterfaceHttp(ajax.delete(`/report/v1/AbilitylevelReferencetype/${id}`)),
  // 获取评价等级
  getAbilityLevelConfig: (params) => InterfaceHttp(ajax.get(`/report/v1/AbilityLevelConfig`, { params })),
  // 新增评价等级
  addAbilityLevelConfig: (params) => InterfaceHttp(ajax.post(`/report/v1/AbilityLevelConfig`, params)),
  // 修改评价等级
  updateAbilityLevelConfig: (params) => InterfaceHttp(ajax.put(`/report/v1/AbilityLevelConfig`, params)),
  // 修改评价等级状态
  statusAbilityLevelConfig: (id) => InterfaceHttp(ajax.put(`/report/v1/AbilityLevelConfig/${id}/status`)),
  // 删除评价等级
  deleteAbilityLevelConfig: (id) => InterfaceHttp(ajax.delete(`/report/v1/AbilityLevelConfig/${id}`)),
  //评价获取游戏数据
  getByAbilityEvaluationSysId: (abilityEvaluationSysId) => InterfaceHttp(ajax.get(`/report/v1/AbilityLevelConfig/GetByAbilityEvaluationSysId/${abilityEvaluationSysId}`)),
  // 报告模板增删改查、详情和修改状态
  ReportTemplates: (params) => InterfaceHttp(ajax.get(`/report/v1/ReportTemplates`, { params })),
  ReportTemplatesAdd: (params) => InterfaceHttp(ajax.post(`/report/v1/ReportTemplates`, params)),
  ReportTemplatesUpdate: (params) => InterfaceHttp(ajax.put(`/report/v1/ReportTemplates`, params)),
  ReportTemplatesDelete: (id) => InterfaceHttp(ajax.delete(`/report/v1/ReportTemplates/${id}`)),
  ReportTemplatesDetails: (id) => InterfaceHttp(ajax.get(`/report/v1/ReportTemplates/${id}`)),
  ReportTemplatesUpdateEnabled: (params) => InterfaceHttp(ajax.put(`/report/v1/ReportTemplates/update-enabled`, params)),

  //用户课程 - 查看报告列表
  UserCourseReportList: (id) => InterfaceHttp(ajax.get(`/report/v1/user-course-reports/${id}`)),
  //重新生成个人课时报告
  UpdateEvaluationReports: (params) => InterfaceHttp(ajax.put(`/report/v1/user-course-reports`, params)),

  getGroupList: (params) => InterfaceHttp(ajax.get('/report/v1/GroupReport', { params })),
  addGroupReport: (params) => InterfaceHttp(ajax.post('/report/v1/GroupReport', params)),
  editGroupReport: (params) => InterfaceHttp(ajax.put('/report/v1/GroupReport', params)),
  getGroupByCId: (id) => InterfaceHttp(ajax.get(`/report/v1/GroupReport/${id}`)),
  deleteGroupReport: (id) => InterfaceHttp(ajax.delete(`/report/v1/GroupReport/${id}`)),
  genGroupReport: (id) => InterfaceHttp(ajax.post(`/report/v1/GroupReport/GenerateGroupReport/${id}`)),
  groupReportCourse: (groupReportId) => InterfaceHttp(ajax.get(`/report/v1/GroupReportCourse/${groupReportId}`)),
  addGroupReportCourse: (params) => InterfaceHttp(ajax.post(`/report/v1/GroupReportCourse`, params)),
  delGroupReportCourse: (id) => InterfaceHttp(ajax.delete(`/report/v1/GroupReportCourse/${id}`)),
  configGroupStudent: (params) => InterfaceHttp(ajax.post(`/report/v1/GroupReportCourse/UpdatParticipantConfig`, params)),
  getConfigGroupStudent: (params) => InterfaceHttp(ajax.post(`/report/v1/GroupReportCourse/GetGroupReportCourseSettings`, params)),
  GetGroupReportProjectCoursechildDetail: (groupReportId) => InterfaceHttp(ajax.get(`/report/v1/GroupReportCourse/GetGroupReportProjectCoursechildDetail/${groupReportId}`)),
  updatContentAbilityConfigs: (params) => InterfaceHttp(ajax.put(`/report/v1/GroupReportCourse/UpdatContentAbilityConfigs`, params)),
  importStudent: (params, config) => InterfaceHttp(ajax.post(`/report/v1/GroupReport/ImportStudent`, params), config),
  importExamScore: (params, config) => InterfaceHttp(ajax.post(`/report/v1/exam/uploadExamScore`, params), config),
  updateTalentContrastTemplate: (params) => InterfaceHttp(ajax.post(`/report/v1/GroupReport/UpdateTalentContrastTemplate`, params)),
  updateGroupExamConfig: (params) => InterfaceHttp(ajax.post(`/report/v1/GroupReport/UpdateGroupExamConfig`, params)),
  clearOrgGroupReportCourse: (params) =>
    InterfaceHttp(
      ajax({
        url: `/report/v1/GroupReportCourse/DeleteOrgGroupReportCourse`,
        method: 'delete',
        data: params,
      })
    ),
  getGroupReportSample: (groupReportId) => InterfaceHttp(ajax.get(`/report/v1/GroupReportSample/${groupReportId}`)),
  updateGroupReportSample: (params) => InterfaceHttp(ajax.put(`/report/v1/GroupReportSample`, params)),
  delGroupReportSample: (params) => InterfaceHttp(ajax.delete(`/report/v1/GroupReportSample/id`, { params })),
  delGroupReportMatch: (groupReportId) => InterfaceHttp(ajax.delete(`/report/v1/GroupReport/DeleteMatch/${groupReportId} `)),
  // 拷贝报告
  copyGroupReport: (groupReportId) => InterfaceHttp(ajax.post(`/report/v1/GroupReport/copy/${groupReportId}`)),
  // 成绩管理
  getGradeExam: (params) => InterfaceHttp(ajax.get(`/report/v1/exam`, { params })),
  delGradeExam: (params) => InterfaceHttp(ajax.delete(`/report/v1/exam/${params.id}`)),
  updateGradeStatus: (params) => InterfaceHttp(ajax.put(`/report/v1/exam/audit/${params.id}`)),
  downloadGradeExam: (params) => InterfaceHttp(ajax.post(`/report/v1/exam/down/${params.id}`)),
  chooseReportExam: (params, config) => InterfaceHttp(ajax.post(`/report/v1/GroupReport/chooseExam`, params), config),
  deleteReportExam: (params) => InterfaceHttp(ajax.delete(`/report/v1/GroupReport/DeleteReportExam/${params.id}`)),

  // 后台-团体训练报告-新增
  GroupTrainingReportPost: (params) => InterfaceHttp(ajax.post(`/report/v1/GroupTrainingReport`, params)),
  // 后台-团体训练报告-编辑基础信息
  GroupTrainingReportPut: (params) => InterfaceHttp(ajax.put(`/report/v1/GroupTrainingReport`, params)),
  // 后台-团体训练报告-配置课程
  GroupTrainingReportCourse: (params) => InterfaceHttp(ajax.put(`/report/v1/GroupTrainingReport/course`, params)),
  // 后台-团体训练报告-配置能力维度
  GroupTrainingReportAbility: (params) => InterfaceHttp(ajax.put(`/report/v1/GroupTrainingReport/ability`, params)),
  // 后台-团体训练报告-配置班级
  GroupTrainingReportClass: (params) => InterfaceHttp(ajax.put(`/report/v1/GroupTrainingReport/class`, params)),
  // 后台-团体训练报告-详情
  GroupTrainingReportDetails: (params) => InterfaceHttp(ajax.get(`/report/v1/GroupTrainingReport/${params}`)),
  // 后台-团体训练报告-删除
  GroupTrainingReportDelete: (params) => InterfaceHttp(ajax.delete(`/report/v1/GroupTrainingReport/${params}`)),
  GroupTrainingReportCourseConfig: (params, config) => InterfaceHttp(ajax.get(`/report/v1/GroupTrainingReport/course-config/${params}`), config),
  GroupTrainingReportAbilityConfig: (params) => InterfaceHttp(ajax.get(`/report/v1/GroupTrainingReport/course-abilities/${params}`)),
  GroupTrainingReportClassTree: (params) => InterfaceHttp(ajax.get(`/report/v1/GroupTrainingReport/class-tree/${params}`)),
  GroupTrainingReportGenerate: (params) => InterfaceHttp(ajax.post(`/report/v1/GroupTrainingReport/generate/${params}`)),
  GroupTrainingReportPagelist: (params) => InterfaceHttp(ajax.get(`/report/v1/GroupTrainingReport`, {params})),
  GroupTrainingReportCopy: (params) => InterfaceHttp(ajax.post(`/report/v1/GroupTrainingReport/copy/${params}`)),
  GroupTrainingReportCourseDelete: (params) => InterfaceHttp(ajax.delete(`/report/v1/GroupTrainingReport/course/${params}`)),
}

// 跳过率看板
export const getSkipList = (params) => InterfaceHttp(ajax.get('/log/v1/GameLog/ContentSkipPageList', { params }))
export const ContentSkipInfoPageList = (params) => InterfaceHttp(ajax.get('/log/v1/GameLog/ContentSkipInfoPageList?' + serializeData(params)))
// 修改记录
export const getHisRecordList = (params) => InterfaceHttp(ajax.get('/content/v1/TrainGameCheckpointHistory/GetRecordPageList', { params }))
export const getRecordInfo = (params) => InterfaceHttp(ajax.get('/content/v1/TrainGameCheckpointHistory/GetRecordInfo', { params }))
// 机构数据统计
export const getResourceLog = (params) => InterfaceHttp(ajax.get('/2b/coursecenter/v1/OrganizationResourceLog/GetPageList', { params }))

export const GroupReportTemp = {
  getList: (params) => InterfaceHttp(ajax.get(`/report/v1/GroupReportTemplate`, { params })),
  addReportTemplate: (params) => InterfaceHttp(ajax.post(`/report/v1/GroupReportTemplate`, params)),
  editReportTemplate: (params) => InterfaceHttp(ajax.put(`/report/v1/GroupReportTemplate`, params)),
  detailReportTemp: (id) => InterfaceHttp(ajax.get(`/report/v1/GroupReportTemplate/${id}`)),
  delReportTemp: (id) => InterfaceHttp(ajax.delete(`/report/v1/GroupReportTemplate/${id}`)),
  editReportTempDesc: (params) => InterfaceHttp(ajax.put(`/report/v1/GroupReportTemplate/content`, params)),
}

export const CourseLearningService = {
  // 获取课时分数
  getUserCourseChildScore: (params) => InterfaceHttp(ajax.get(`/courseLearning/v1/user-course-session/${params}/settlement`)),
}

// 系统日志
export const SysLog = {
  // 日志分页列表
  pageList: (params) => InterfaceHttp(ajax.get(`/log/v1/SysLog/SysLogPageList`, { params })),
}
